<template>
  <section class="ibcgp-fiscais-note" aria-label="Informação complementar">
    <div class="container">
      <p class="ibcgp-fiscais-note-text mb-0 text-center">
        <a href="/fiscais" class="ibcgp-fiscais-note-link">
          Credenciamento para fiscais em processos seletivos
        </a>
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FiscaisAsideSection'
}
</script>

<style scoped>
.ibcgp-fiscais-note {
  padding: 0.65rem 0;
  background: #f1f5f9;
  border-top: 1px solid rgba(2, 34, 91, 0.06);
}

.ibcgp-fiscais-note-text {
  font-size: 0.78rem;
  line-height: 1.4;
}

.ibcgp-fiscais-note-link {
  color: #94a3b8;
  font-weight: 500;
}

.ibcgp-fiscais-note-link:hover {
  color: #64748b;
  text-decoration: underline;
}
</style>
